module.exports = __webpack_public_path__ + "img/polyackiy.4d322092.jpg";